import { Link } from 'react-router-dom';
import { User, SignOut } from '@phosphor-icons/react';
import { dashboardPathFor } from './navConfig';

// Auth-related elements for the navbar (Login/Get Started or Dashboard/Logout)
export const NavbarAuthDesktop = ({ user, onLogout }) => {
  if (user) {
    return (
      <>
        <Link
          to={dashboardPathFor(user.role)}
          className="flex items-center gap-2 text-sm font-medium text-gray-700 hover:text-[#F97316]"
          data-testid="nav-dashboard"
        >
          <User size={16} weight="bold" />
          Dashboard
        </Link>
        <button
          onClick={onLogout}
          className="text-sm font-medium text-gray-500 hover:text-gray-900"
          data-testid="nav-logout"
        >
          Logout
        </button>
      </>
    );
  }
  return (
    <>
      <Link to="/login" className="text-sm font-medium text-gray-700 hover:text-[#F97316]" data-testid="nav-login">
        Login
      </Link>
      <Link
        to="/register"
        className="btn-primary px-5 py-2 rounded-full text-sm font-semibold"
        data-testid="nav-register"
      >
        Get Started
      </Link>
    </>
  );
};

export const NavbarAuthMobile = ({ user, onLogout, onClose }) => {
  if (user) {
    return (
      <>
        <Link to={dashboardPathFor(user.role)} onClick={onClose} className="flex items-center gap-2 py-2 text-base font-medium text-gray-900">
          <User size={18} weight="bold" /> Dashboard
        </Link>
        <button onClick={onLogout} className="flex items-center gap-2 py-2 text-base font-medium text-gray-500">
          <SignOut size={18} weight="bold" /> Logout
        </button>
      </>
    );
  }
  return (
    <>
      <Link to="/login" onClick={onClose} className="block py-2 text-base font-medium text-gray-700">Login</Link>
      <Link to="/register" onClick={onClose} className="btn-primary block text-center px-5 py-3 rounded-full text-sm font-semibold">Get Started</Link>
    </>
  );
};
